export default __webpack_public_path__ + "static/media/3.6bbd0d58.jpg";